import { PageHeading } from '../../../../../components'
import { useClienteAtual } from '../core/useClienteAtual'

/**
 * Cabeçalho das telas filhas de um empregador ASO (cargos, setores, coordenadores...), acima do
 * <TableCard>: nome do empregador como título; documento e instituição como apoio.
 */
export const ClienteHeading = () => {
  const cliente = useClienteAtual()

  const documento = [cliente?.tipoDocumento, cliente?.documento].filter(Boolean).join(' ')
  const descricao = [documento].filter(Boolean).join(' · ')

  return (
    <PageHeading
      title={cliente?.nome ?? 'Carregando empregador…'}
      description={descricao || undefined}
    />
  )
}
